


















import { Vue, Component } from "vue-property-decorator"
import BuyItem from "./BuyItem.vue"
@Component({
  components: {
    BuyItem
  }
})
export default class BuyMenu extends Vue {
  get energySources() {
    return this.$store.getters.energySources
  }
}
